export const JSS_LABEL = 'custom-css-insertion-point';

/**
 * Setups the point where the MUI files will be injected. It is needed to override
 * the styles of the library.
 * @param {JSS} jss - New jss instance.
 * @param {string} label - New jss instance.
 */
export const setupStylesInjectionPoint = (label = 'custom-insertion-point') => {
  // We define a custom insertion point that JSS will look for injecting the styles in the DOM.
  const styleNode = document.createComment(label);
  document.head.insertBefore(styleNode, document.head.firstChild);
}
